<span>
  <div [class]="'employee-status-wrapper '">
    <div [class]="'employee-status ' + statusClassName">
      <span>{{ statusLabel }}</span>
    </div>
  </div>
</span>
